import { connect, ResolveThunks } from "react-redux";
import { actions } from "state/slices/userSlice";
import { useNavigate } from "react-router";
import { LegalScroller } from "components/legal/LegalScroller";
import { useState } from "react";

interface StateProps {}

interface DispatchProps {
  onAcceptTerms: typeof actions.acceptTerms;
}

type Props = StateProps & ResolveThunks<DispatchProps>;

type ValueOf<T> = T[keyof T];

const fState = {
  TERMS: "TERMS",
  PRIVACY: "PRIVACY",
} as const;

type TState = ValueOf<typeof fState>;

const AcceptTermsPage = (props: Props): JSX.Element => {
  const [state, setState] = useState<TState>(fState.TERMS);
  const [scrolled, setHasScrolled] = useState(false);

  const navigate = useNavigate();

  const onAcceptPrivacyPolicy = () => {
    props.onAcceptTerms(navigate);
  };

  const onAcceptTerms = async () => {
    setState(fState.PRIVACY);
    await new Promise<void>((resolve) => {
      setTimeout(() => {
        resolve();
      }, 100);
    });
    setHasScrolled(false);
  };

  const isTerms = state === fState.TERMS;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-bg p-3 sm:p-8">
      <div className="flex flex-col w-full max-w-2xl h-full max-h-[48rem] bg-surface border border-rule rounded-token overflow-hidden">
        <div className="flex-none px-5 pt-5 pb-4 border-b border-rule">
          <p className="text-xs uppercase tracking-wide text-muted m-0">
            Step {isTerms ? 1 : 2} of 2
          </p>
          <h1 className="text-xl font-bold text-ink mt-1 mb-2">
            Review and accept
          </h1>
          <p className="text-sm text-ink-2 m-0">
            Please read and accept the terms of service and privacy policy to
            use Vybe. You can find both again later in the links at the bottom
            of every page.
          </p>
        </div>

        {/* LegalScroller must remain the scroll container: its onScroll is
            what enables the accept button. Wrapping it in another scrolling
            element would stop it scrolling, and nobody could accept. */}
        <LegalScroller
          type={state}
          setHasScrolled={() => setHasScrolled(true)}
        />

        <div className="flex-none flex flex-wrap items-center justify-end gap-3 px-5 py-3 bg-raised border-t border-rule">
          {!scrolled && (
            <span className="text-xs text-muted mr-auto">
              Scroll through the document to continue.
            </span>
          )}
          <button
            disabled={!scrolled}
            type="button"
            className="button-primary"
            onClick={isTerms ? onAcceptTerms : onAcceptPrivacyPolicy}
          >
            {isTerms ? "Accept terms" : "Accept privacy policy"}
          </button>
        </div>
      </div>
    </div>
  );
};

const mapDispatch: DispatchProps = {
  onAcceptTerms: actions.acceptTerms,
};

export default connect(null, mapDispatch)(AcceptTermsPage);
